import { Dimensions, Quantity, Unit } from '@elderbyte/ngx-starter'

export class StorageNode {
  public id: string

  public number: string

  public facility: string

  public type: StorageNodeType

  public ancestors: string[]

  public parent: string

  public priority: number

  public path: string

  public description: string

  public capacity: StorageNodeCapacity = new StorageNodeCapacity()

  public packageCheckinMode: PackageCheckinMode

  public activated: boolean
}

export enum StorageNodeType {
  Logical = 'LOGICAL',

  Physical = 'PHYSICAL',
}

export enum PackageCheckinMode {
  AUTO = 'AUTO',

  SEMI_AUTO = 'SEMI_AUTO',

  MANUAL = 'MANUAL',
}

export class StorageNodeCapacity {
  public minWeight: Quantity = Quantity.zero(Unit.kg)

  public maxWeight: Quantity = Quantity.zero(Unit.kg)

  public dimensions: Dimensions = Dimensions.zero(Unit.cm)

  public multiOrderModeEnabled: boolean
}

export class StorageNodeAssignment {
  public storageNodeId: string
  public weight: Quantity
  public contentWeight: Quantity
  public packageCount: number
  public storageGroupCount: number
}
